import { FC } from 'react';
import scrollTopIcon from 'assets/icons/scroll-top-light.svg';
import { useExamsSchedule } from 'features/index';
import { EmptyBlank } from 'widgets/schedule/emptyBlank';

import { ContainerSchedule } from '../containerSchedule';
import { useScroll } from '../hooks';
import { SkeletonSchedule } from '../skeletonSchedule';
import { TableSchedule } from '../tableSchedule';

import styles from './styles.module.scss';

export const StageExamsTableSchedule: FC = () => {
  const { dataForGroupExamsSchedule, isSkeleton } = useExamsSchedule();

  const {
    containerScheduleRef,
    handleMouseDown,
    handleMouseLeave,
    handleMouseMove,
    handleMouseUp,
    handleScroll,
    isDragging,
    isScrollToTopVisible,
    scrollToTop,
  } = useScroll();

  return (
    <div
      className={styles['stage-table-schedule']}
      style={{ cursor: isDragging ? 'grabbing' : 'default' }}
      ref={containerScheduleRef}
      onScroll={handleScroll}
      onMouseDown={handleMouseDown}
      onMouseLeave={handleMouseLeave}
      onMouseUp={handleMouseUp}
      onMouseMove={handleMouseMove}
    >
      <ContainerSchedule>
        {isSkeleton ? (
          <SkeletonSchedule />
        ) : dataForGroupExamsSchedule.length !== 0 ? (
          <TableSchedule dataSchedule={dataForGroupExamsSchedule} />
        ) : (
          <EmptyBlank />
        )}
      </ContainerSchedule>
      {isScrollToTopVisible && (
        <button className={styles['scroll-top-button']} onClick={scrollToTop}>
          <img
            className={styles['scroll-top-button__icon']}
            src={scrollTopIcon}
          />
        </button>
      )}
    </div>
  );
};
